import React, { useEffect, useState } from "react";
import { TableRow, TableCell, useTheme } from "@mui/material";
import Moment from "react-moment";
import TableView from "./util/TableView";
import { ModuleHeader } from "../../components/composed";
import { Badge } from "../../components/primitives";
import { FadeIn } from "../../components/motion";

export default function UsersLoginView(props) {
  const theme = useTheme();
  const [data, setData] = useState([]);

  useEffect(() => {
    props.setShowSearch(false);
  }, []);

  const tableHeader = (
    <TableRow>
      <TableCell>Name</TableCell>
      <TableCell>Date</TableCell>
      <TableCell>Location</TableCell>
    </TableRow>
  );

  const tableRows = (userLogin, index) => (
    <TableRow key={userLogin.id}>
      <TableCell>{userLogin.user.name}</TableCell>
      <TableCell>
        <Moment date={userLogin.date} format="HH:mm:SS DD/MM/YYYY" />
      </TableCell>
      <TableCell>{userLogin.user.city}, {userLogin.user.country}</TableCell>
    </TableRow>
  );


  return (
    <FadeIn>
      <ModuleHeader
        title="Login History"
        subtitle="Track user login activity and access patterns"
        moduleColor={theme.palette.primary.main}
      />
      <TableView
        fetchUrl={"user/login/all"}
        tableHeader={tableHeader}
        tableRows={tableRows}
        searchValue={props.searchValue}
        data={data}
        setData={setData}
        {...props}
      />
    </FadeIn>
  );
}
